<template>
  <div>
    jde

    <v-btn @click.stop="showPop = true">
      showPop
    </v-btn>

    <v-btn @click.stop="test3">
      test
    </v-btn>

    <jdePop :showPop.sync="showPop" />

    <div style="background: blue;" class="pa-8" @click="test1">
      <div style="background: yellow;" @click.stop="test2">
        Click Test
      </div>
    </div>
  </div>
</template>

<script>
import jdePop from '@/views/test/popup/jdePop';

export default {
  components: {
    jdePop
  },
  data() {
    return {
      showPop: false,
      sys: this.$store.state.system.sysCd
    }
  },
  methods: {
    test1() {
      console.log('test1')
    },
    test2() {
      console.log('test2')
    },
    test3() {
      // console.log('sys', this.sys)

      const testNULL = null
      console.log('testNULL', testNULL ? true : false)

      let testUNDEFINED
      console.log('testUNDEFINED', testUNDEFINED ? true : false)

      const testEMPTY = ''
      console.log('testEMPTY', testEMPTY ? true : false)

      const testBLANK = ' '
      console.log('testBLANK', testBLANK ? true : false)

      if(testUNDEFINED != null && testUNDEFINED === "Y"){
        console.log('aaazzz')
        return
      }

      const aaa = ''
      if(aaa === null && aaa === '') {
        console.log('aaa')
      }
    }
  },
  mounted() {
  },
}
</script>